var map = {
	"./flags/Afghanistan.svg": "./svg/flags/Afghanistan.svg",
	"./flags/Albania.svg": "./svg/flags/Albania.svg",
	"./flags/Algeria.svg": "./svg/flags/Algeria.svg",
	"./flags/American Samoa.svg": "./svg/flags/American Samoa.svg",
	"./flags/Andorra.svg": "./svg/flags/Andorra.svg",
	"./flags/Angola.svg": "./svg/flags/Angola.svg",
	"./flags/Anguilla.svg": "./svg/flags/Anguilla.svg",
	"./flags/Antarctica.svg": "./svg/flags/Antarctica.svg",
	"./flags/Antigua and Barbuda.svg": "./svg/flags/Antigua and Barbuda.svg",
	"./flags/Argentina.svg": "./svg/flags/Argentina.svg",
	"./flags/Armenia.svg": "./svg/flags/Armenia.svg",
	"./flags/Aruba.svg": "./svg/flags/Aruba.svg",
	"./flags/Australia.svg": "./svg/flags/Australia.svg",
	"./flags/Austria.svg": "./svg/flags/Austria.svg",
	"./flags/Azerbaijan.svg": "./svg/flags/Azerbaijan.svg",
	"./flags/Bahamas.svg": "./svg/flags/Bahamas.svg",
	"./flags/Bahrain.svg": "./svg/flags/Bahrain.svg",
	"./flags/Bangladesh.svg": "./svg/flags/Bangladesh.svg",
	"./flags/Barbados.svg": "./svg/flags/Barbados.svg",
	"./flags/Belarus.svg": "./svg/flags/Belarus.svg",
	"./flags/Belgium.svg": "./svg/flags/Belgium.svg",
	"./flags/Belize.svg": "./svg/flags/Belize.svg",
	"./flags/Benin.svg": "./svg/flags/Benin.svg",
	"./flags/Bermuda.svg": "./svg/flags/Bermuda.svg",
	"./flags/Bhutan.svg": "./svg/flags/Bhutan.svg",
	"./flags/Bolivia, Plurinational State of.svg": "./svg/flags/Bolivia, Plurinational State of.svg",
	"./flags/Bonaire, Sint Eustatius and Saba.svg": "./svg/flags/Bonaire, Sint Eustatius and Saba.svg",
	"./flags/Bosnia and Herzegovina.svg": "./svg/flags/Bosnia and Herzegovina.svg",
	"./flags/Botswana.svg": "./svg/flags/Botswana.svg",
	"./flags/Bouvet Island.svg": "./svg/flags/Bouvet Island.svg",
	"./flags/Brazil.svg": "./svg/flags/Brazil.svg",
	"./flags/British Indian Ocean Territory.svg": "./svg/flags/British Indian Ocean Territory.svg",
	"./flags/Brunei Darussalam.svg": "./svg/flags/Brunei Darussalam.svg",
	"./flags/Bulgaria.svg": "./svg/flags/Bulgaria.svg",
	"./flags/Burkina Faso.svg": "./svg/flags/Burkina Faso.svg",
	"./flags/Burundi.svg": "./svg/flags/Burundi.svg",
	"./flags/Cabo Verde.svg": "./svg/flags/Cabo Verde.svg",
	"./flags/Cambodia.svg": "./svg/flags/Cambodia.svg",
	"./flags/Cameroon.svg": "./svg/flags/Cameroon.svg",
	"./flags/Canada.svg": "./svg/flags/Canada.svg",
	"./flags/Cayman Islands.svg": "./svg/flags/Cayman Islands.svg",
	"./flags/Central African Republic.svg": "./svg/flags/Central African Republic.svg",
	"./flags/Chad.svg": "./svg/flags/Chad.svg",
	"./flags/Chile.svg": "./svg/flags/Chile.svg",
	"./flags/China.svg": "./svg/flags/China.svg",
	"./flags/Christmas Island.svg": "./svg/flags/Christmas Island.svg",
	"./flags/Cocos (Keeling) Islands.svg": "./svg/flags/Cocos (Keeling) Islands.svg",
	"./flags/Colombia.svg": "./svg/flags/Colombia.svg",
	"./flags/Comoros.svg": "./svg/flags/Comoros.svg",
	"./flags/Congo, The Democratic Republic of the.svg": "./svg/flags/Congo, The Democratic Republic of the.svg",
	"./flags/Congo.svg": "./svg/flags/Congo.svg",
	"./flags/Cook Islands.svg": "./svg/flags/Cook Islands.svg",
	"./flags/Costa Rica.svg": "./svg/flags/Costa Rica.svg",
	"./flags/Croatia.svg": "./svg/flags/Croatia.svg",
	"./flags/Cuba.svg": "./svg/flags/Cuba.svg",
	"./flags/Curaçao.svg": "./svg/flags/Curaçao.svg",
	"./flags/Cyprus.svg": "./svg/flags/Cyprus.svg",
	"./flags/Czechia.svg": "./svg/flags/Czechia.svg",
	"./flags/Côte d'Ivoire.svg": "./svg/flags/Côte d'Ivoire.svg",
	"./flags/Denmark.svg": "./svg/flags/Denmark.svg",
	"./flags/Djibouti.svg": "./svg/flags/Djibouti.svg",
	"./flags/Dominica.svg": "./svg/flags/Dominica.svg",
	"./flags/Dominican Republic.svg": "./svg/flags/Dominican Republic.svg",
	"./flags/Ecuador.svg": "./svg/flags/Ecuador.svg",
	"./flags/Egypt.svg": "./svg/flags/Egypt.svg",
	"./flags/El Salvador.svg": "./svg/flags/El Salvador.svg",
	"./flags/Equatorial Guinea.svg": "./svg/flags/Equatorial Guinea.svg",
	"./flags/Eritrea.svg": "./svg/flags/Eritrea.svg",
	"./flags/Estonia.svg": "./svg/flags/Estonia.svg",
	"./flags/Eswatini.svg": "./svg/flags/Eswatini.svg",
	"./flags/Ethiopia.svg": "./svg/flags/Ethiopia.svg",
	"./flags/Falkland Islands (Malvinas).svg": "./svg/flags/Falkland Islands (Malvinas).svg",
	"./flags/Faroe Islands.svg": "./svg/flags/Faroe Islands.svg",
	"./flags/Fiji.svg": "./svg/flags/Fiji.svg",
	"./flags/Finland.svg": "./svg/flags/Finland.svg",
	"./flags/France.svg": "./svg/flags/France.svg",
	"./flags/French Guiana.svg": "./svg/flags/French Guiana.svg",
	"./flags/French Polynesia.svg": "./svg/flags/French Polynesia.svg",
	"./flags/French Southern Territories.svg": "./svg/flags/French Southern Territories.svg",
	"./flags/Gabon.svg": "./svg/flags/Gabon.svg",
	"./flags/Gambia.svg": "./svg/flags/Gambia.svg",
	"./flags/Georgia.svg": "./svg/flags/Georgia.svg",
	"./flags/Germany.svg": "./svg/flags/Germany.svg",
	"./flags/Ghana.svg": "./svg/flags/Ghana.svg",
	"./flags/Gibraltar.svg": "./svg/flags/Gibraltar.svg",
	"./flags/Greece.svg": "./svg/flags/Greece.svg",
	"./flags/Greenland.svg": "./svg/flags/Greenland.svg",
	"./flags/Grenada.svg": "./svg/flags/Grenada.svg",
	"./flags/Guadeloupe.svg": "./svg/flags/Guadeloupe.svg",
	"./flags/Guam.svg": "./svg/flags/Guam.svg",
	"./flags/Guatemala.svg": "./svg/flags/Guatemala.svg",
	"./flags/Guernsey.svg": "./svg/flags/Guernsey.svg",
	"./flags/Guinea-Bissau.svg": "./svg/flags/Guinea-Bissau.svg",
	"./flags/Guinea.svg": "./svg/flags/Guinea.svg",
	"./flags/Guyana.svg": "./svg/flags/Guyana.svg",
	"./flags/Haiti.svg": "./svg/flags/Haiti.svg",
	"./flags/Heard Island and McDonald Islands.svg": "./svg/flags/Heard Island and McDonald Islands.svg",
	"./flags/Holy See (Vatican City State).svg": "./svg/flags/Holy See (Vatican City State).svg",
	"./flags/Honduras.svg": "./svg/flags/Honduras.svg",
	"./flags/Hong Kong.svg": "./svg/flags/Hong Kong.svg",
	"./flags/Hungary.svg": "./svg/flags/Hungary.svg",
	"./flags/Iceland.svg": "./svg/flags/Iceland.svg",
	"./flags/India.svg": "./svg/flags/India.svg",
	"./flags/Indonesia.svg": "./svg/flags/Indonesia.svg",
	"./flags/Iran, Islamic Republic of.svg": "./svg/flags/Iran, Islamic Republic of.svg",
	"./flags/Iraq.svg": "./svg/flags/Iraq.svg",
	"./flags/Ireland.svg": "./svg/flags/Ireland.svg",
	"./flags/Isle of Man.svg": "./svg/flags/Isle of Man.svg",
	"./flags/Israel.svg": "./svg/flags/Israel.svg",
	"./flags/Italy.svg": "./svg/flags/Italy.svg",
	"./flags/Jamaica.svg": "./svg/flags/Jamaica.svg",
	"./flags/Japan.svg": "./svg/flags/Japan.svg",
	"./flags/Jersey.svg": "./svg/flags/Jersey.svg",
	"./flags/Jordan.svg": "./svg/flags/Jordan.svg",
	"./flags/Kazakhstan.svg": "./svg/flags/Kazakhstan.svg",
	"./flags/Kenya.svg": "./svg/flags/Kenya.svg",
	"./flags/Kiribati.svg": "./svg/flags/Kiribati.svg",
	"./flags/Korea, Democratic People's Republic of.svg": "./svg/flags/Korea, Democratic People's Republic of.svg",
	"./flags/Korea, Republic of.svg": "./svg/flags/Korea, Republic of.svg",
	"./flags/Kuwait.svg": "./svg/flags/Kuwait.svg",
	"./flags/Kyrgyzstan.svg": "./svg/flags/Kyrgyzstan.svg",
	"./flags/Lao People's Democratic Republic.svg": "./svg/flags/Lao People's Democratic Republic.svg",
	"./flags/Latvia.svg": "./svg/flags/Latvia.svg",
	"./flags/Lebanon.svg": "./svg/flags/Lebanon.svg",
	"./flags/Lesotho.svg": "./svg/flags/Lesotho.svg",
	"./flags/Liberia.svg": "./svg/flags/Liberia.svg",
	"./flags/Libya.svg": "./svg/flags/Libya.svg",
	"./flags/Liechtenstein.svg": "./svg/flags/Liechtenstein.svg",
	"./flags/Lithuania.svg": "./svg/flags/Lithuania.svg",
	"./flags/Luxembourg.svg": "./svg/flags/Luxembourg.svg",
	"./flags/Macao.svg": "./svg/flags/Macao.svg",
	"./flags/Madagascar.svg": "./svg/flags/Madagascar.svg",
	"./flags/Malawi.svg": "./svg/flags/Malawi.svg",
	"./flags/Malaysia.svg": "./svg/flags/Malaysia.svg",
	"./flags/Maldives.svg": "./svg/flags/Maldives.svg",
	"./flags/Mali.svg": "./svg/flags/Mali.svg",
	"./flags/Malta.svg": "./svg/flags/Malta.svg",
	"./flags/Marshall Islands.svg": "./svg/flags/Marshall Islands.svg",
	"./flags/Martinique.svg": "./svg/flags/Martinique.svg",
	"./flags/Mauritania.svg": "./svg/flags/Mauritania.svg",
	"./flags/Mauritius.svg": "./svg/flags/Mauritius.svg",
	"./flags/Mayotte.svg": "./svg/flags/Mayotte.svg",
	"./flags/Mexico.svg": "./svg/flags/Mexico.svg",
	"./flags/Micronesia, Federated States of.svg": "./svg/flags/Micronesia, Federated States of.svg",
	"./flags/Moldova, Republic of.svg": "./svg/flags/Moldova, Republic of.svg",
	"./flags/Monaco.svg": "./svg/flags/Monaco.svg",
	"./flags/Mongolia.svg": "./svg/flags/Mongolia.svg",
	"./flags/Montenegro.svg": "./svg/flags/Montenegro.svg",
	"./flags/Montserrat.svg": "./svg/flags/Montserrat.svg",
	"./flags/Morocco.svg": "./svg/flags/Morocco.svg",
	"./flags/Mozambique.svg": "./svg/flags/Mozambique.svg",
	"./flags/Myanmar.svg": "./svg/flags/Myanmar.svg",
	"./flags/Namibia.svg": "./svg/flags/Namibia.svg",
	"./flags/Nauru.svg": "./svg/flags/Nauru.svg",
	"./flags/Nepal.svg": "./svg/flags/Nepal.svg",
	"./flags/Netherlands.svg": "./svg/flags/Netherlands.svg",
	"./flags/New Caledonia.svg": "./svg/flags/New Caledonia.svg",
	"./flags/New Zealand.svg": "./svg/flags/New Zealand.svg",
	"./flags/Nicaragua.svg": "./svg/flags/Nicaragua.svg",
	"./flags/Niger.svg": "./svg/flags/Niger.svg",
	"./flags/Nigeria.svg": "./svg/flags/Nigeria.svg",
	"./flags/Niue.svg": "./svg/flags/Niue.svg",
	"./flags/Norfolk Island.svg": "./svg/flags/Norfolk Island.svg",
	"./flags/North Macedonia.svg": "./svg/flags/North Macedonia.svg",
	"./flags/Northern Mariana Islands.svg": "./svg/flags/Northern Mariana Islands.svg",
	"./flags/Norway.svg": "./svg/flags/Norway.svg",
	"./flags/Oman.svg": "./svg/flags/Oman.svg",
	"./flags/Pakistan.svg": "./svg/flags/Pakistan.svg",
	"./flags/Palau.svg": "./svg/flags/Palau.svg",
	"./flags/Palestine, State of.svg": "./svg/flags/Palestine, State of.svg",
	"./flags/Panama.svg": "./svg/flags/Panama.svg",
	"./flags/Papua New Guinea.svg": "./svg/flags/Papua New Guinea.svg",
	"./flags/Paraguay.svg": "./svg/flags/Paraguay.svg",
	"./flags/Peru.svg": "./svg/flags/Peru.svg",
	"./flags/Philippines.svg": "./svg/flags/Philippines.svg",
	"./flags/Pitcairn.svg": "./svg/flags/Pitcairn.svg",
	"./flags/Poland.svg": "./svg/flags/Poland.svg",
	"./flags/Portugal.svg": "./svg/flags/Portugal.svg",
	"./flags/Puerto Rico.svg": "./svg/flags/Puerto Rico.svg",
	"./flags/Qatar.svg": "./svg/flags/Qatar.svg",
	"./flags/Romania.svg": "./svg/flags/Romania.svg",
	"./flags/Russian Federation.svg": "./svg/flags/Russian Federation.svg",
	"./flags/Rwanda.svg": "./svg/flags/Rwanda.svg",
	"./flags/Réunion.svg": "./svg/flags/Réunion.svg",
	"./flags/Saint Barthélemy.svg": "./svg/flags/Saint Barthélemy.svg",
	"./flags/Saint Helena, Ascension and Tristan da Cunha.svg": "./svg/flags/Saint Helena, Ascension and Tristan da Cunha.svg",
	"./flags/Saint Kitts and Nevis.svg": "./svg/flags/Saint Kitts and Nevis.svg",
	"./flags/Saint Lucia.svg": "./svg/flags/Saint Lucia.svg",
	"./flags/Saint Martin (French part).svg": "./svg/flags/Saint Martin (French part).svg",
	"./flags/Saint Pierre and Miquelon.svg": "./svg/flags/Saint Pierre and Miquelon.svg",
	"./flags/Saint Vincent and the Grenadines.svg": "./svg/flags/Saint Vincent and the Grenadines.svg",
	"./flags/Samoa.svg": "./svg/flags/Samoa.svg",
	"./flags/San Marino.svg": "./svg/flags/San Marino.svg",
	"./flags/Sao Tome and Principe.svg": "./svg/flags/Sao Tome and Principe.svg",
	"./flags/Saudi Arabia.svg": "./svg/flags/Saudi Arabia.svg",
	"./flags/Senegal.svg": "./svg/flags/Senegal.svg",
	"./flags/Serbia.svg": "./svg/flags/Serbia.svg",
	"./flags/Seychelles.svg": "./svg/flags/Seychelles.svg",
	"./flags/Sierra Leone.svg": "./svg/flags/Sierra Leone.svg",
	"./flags/Singapore.svg": "./svg/flags/Singapore.svg",
	"./flags/Sint Maarten (Dutch part).svg": "./svg/flags/Sint Maarten (Dutch part).svg",
	"./flags/Slovakia.svg": "./svg/flags/Slovakia.svg",
	"./flags/Slovenia.svg": "./svg/flags/Slovenia.svg",
	"./flags/Solomon Islands.svg": "./svg/flags/Solomon Islands.svg",
	"./flags/Somalia.svg": "./svg/flags/Somalia.svg",
	"./flags/South Africa.svg": "./svg/flags/South Africa.svg",
	"./flags/South Georgia and the South Sandwich Islands.svg": "./svg/flags/South Georgia and the South Sandwich Islands.svg",
	"./flags/South Sudan.svg": "./svg/flags/South Sudan.svg",
	"./flags/Spain.svg": "./svg/flags/Spain.svg",
	"./flags/Sri Lanka.svg": "./svg/flags/Sri Lanka.svg",
	"./flags/Sudan.svg": "./svg/flags/Sudan.svg",
	"./flags/Suriname.svg": "./svg/flags/Suriname.svg",
	"./flags/Svalbard and Jan Mayen.svg": "./svg/flags/Svalbard and Jan Mayen.svg",
	"./flags/Sweden.svg": "./svg/flags/Sweden.svg",
	"./flags/Switzerland.svg": "./svg/flags/Switzerland.svg",
	"./flags/Syrian Arab Republic.svg": "./svg/flags/Syrian Arab Republic.svg",
	"./flags/Taiwan, Province of China.svg": "./svg/flags/Taiwan, Province of China.svg",
	"./flags/Tajikistan.svg": "./svg/flags/Tajikistan.svg",
	"./flags/Tanzania, United Republic of.svg": "./svg/flags/Tanzania, United Republic of.svg",
	"./flags/Thailand.svg": "./svg/flags/Thailand.svg",
	"./flags/Timor-Leste.svg": "./svg/flags/Timor-Leste.svg",
	"./flags/Togo.svg": "./svg/flags/Togo.svg",
	"./flags/Tokelau.svg": "./svg/flags/Tokelau.svg",
	"./flags/Tonga.svg": "./svg/flags/Tonga.svg",
	"./flags/Trinidad and Tobago.svg": "./svg/flags/Trinidad and Tobago.svg",
	"./flags/Tunisia.svg": "./svg/flags/Tunisia.svg",
	"./flags/Turkey.svg": "./svg/flags/Turkey.svg",
	"./flags/Turkmenistan.svg": "./svg/flags/Turkmenistan.svg",
	"./flags/Turks and Caicos Islands.svg": "./svg/flags/Turks and Caicos Islands.svg",
	"./flags/Tuvalu.svg": "./svg/flags/Tuvalu.svg",
	"./flags/Uganda.svg": "./svg/flags/Uganda.svg",
	"./flags/Ukraine.svg": "./svg/flags/Ukraine.svg",
	"./flags/United Arab Emirates.svg": "./svg/flags/United Arab Emirates.svg",
	"./flags/United Kingdom.svg": "./svg/flags/United Kingdom.svg",
	"./flags/United States Minor Outlying Islands.svg": "./svg/flags/United States Minor Outlying Islands.svg",
	"./flags/United States.svg": "./svg/flags/United States.svg",
	"./flags/Uruguay.svg": "./svg/flags/Uruguay.svg",
	"./flags/Uzbekistan.svg": "./svg/flags/Uzbekistan.svg",
	"./flags/Vanuatu.svg": "./svg/flags/Vanuatu.svg",
	"./flags/Venezuela, Bolivarian Republic of.svg": "./svg/flags/Venezuela, Bolivarian Republic of.svg",
	"./flags/Viet Nam.svg": "./svg/flags/Viet Nam.svg",
	"./flags/Virgin Islands, British.svg": "./svg/flags/Virgin Islands, British.svg",
	"./flags/Virgin Islands, U.S..svg": "./svg/flags/Virgin Islands, U.S..svg",
	"./flags/Wallis and Futuna.svg": "./svg/flags/Wallis and Futuna.svg",
	"./flags/Western Sahara.svg": "./svg/flags/Western Sahara.svg",
	"./flags/Yemen.svg": "./svg/flags/Yemen.svg",
	"./flags/Zambia.svg": "./svg/flags/Zambia.svg",
	"./flags/Zimbabwe.svg": "./svg/flags/Zimbabwe.svg",
	"./flags/arab.svg": "./svg/flags/arab.svg",
	"./flags/asean.svg": "./svg/flags/asean.svg",
	"./flags/cefta.svg": "./svg/flags/cefta.svg",
	"./flags/cp.svg": "./svg/flags/cp.svg",
	"./flags/dg.svg": "./svg/flags/dg.svg",
	"./flags/eac.svg": "./svg/flags/eac.svg",
	"./flags/es-ct.svg": "./svg/flags/es-ct.svg",
	"./flags/es-ga.svg": "./svg/flags/es-ga.svg",
	"./flags/es-pv.svg": "./svg/flags/es-pv.svg",
	"./flags/eu.svg": "./svg/flags/eu.svg",
	"./flags/gb-eng.svg": "./svg/flags/gb-eng.svg",
	"./flags/gb-nir.svg": "./svg/flags/gb-nir.svg",
	"./flags/gb-sct.svg": "./svg/flags/gb-sct.svg",
	"./flags/gb-wls.svg": "./svg/flags/gb-wls.svg",
	"./flags/ic.svg": "./svg/flags/ic.svg",
	"./flags/pc.svg": "./svg/flags/pc.svg",
	"./flags/sh-ac.svg": "./svg/flags/sh-ac.svg",
	"./flags/sh-hl.svg": "./svg/flags/sh-hl.svg",
	"./flags/sh-ta.svg": "./svg/flags/sh-ta.svg",
	"./flags/un.svg": "./svg/flags/un.svg",
	"./flags/xk.svg": "./svg/flags/xk.svg",
	"./flags/Åland Islands.svg": "./svg/flags/Åland Islands.svg",
	"./footer-province.svg": "./svg/footer-province.svg",
	"./footer-wave.svg": "./svg/footer-wave.svg",
	"./icon-aerospace.svg": "./svg/icon-aerospace.svg",
	"./icon-agrifood.svg": "./svg/icon-agrifood.svg",
	"./icon-arrow-left.svg": "./svg/icon-arrow-left.svg",
	"./icon-arrow-link-down.svg": "./svg/icon-arrow-link-down.svg",
	"./icon-arrow-link.svg": "./svg/icon-arrow-link.svg",
	"./icon-arrow-long.svg": "./svg/icon-arrow-long.svg",
	"./icon-arrow-right.svg": "./svg/icon-arrow-right.svg",
	"./icon-arrow-white.svg": "./svg/icon-arrow-white.svg",
	"./icon-biobased.svg": "./svg/icon-biobased.svg",
	"./icon-checkmark-color-secondary.svg": "./svg/icon-checkmark-color-secondary.svg",
	"./icon-checkmark-spaced.svg": "./svg/icon-checkmark-spaced.svg",
	"./icon-checkmark.svg": "./svg/icon-checkmark.svg",
	"./icon-chemical.svg": "./svg/icon-chemical.svg",
	"./icon-chevron-color-secondary.svg": "./svg/icon-chevron-color-secondary.svg",
	"./icon-chevron.svg": "./svg/icon-chevron.svg",
	"./icon-close.svg": "./svg/icon-close.svg",
	"./icon-diamond-default.svg": "./svg/icon-diamond-default.svg",
	"./icon-diamond-white.svg": "./svg/icon-diamond-white.svg",
	"./icon-diamond.svg": "./svg/icon-diamond.svg",
	"./icon-education.svg": "./svg/icon-education.svg",
	"./icon-email.svg": "./svg/icon-email.svg",
	"./icon-external-link.svg": "./svg/icon-external-link.svg",
	"./icon-facebook.svg": "./svg/icon-facebook.svg",
	"./icon-file-pdf.svg": "./svg/icon-file-pdf.svg",
	"./icon-file.svg": "./svg/icon-file.svg",
	"./icon-filter.svg": "./svg/icon-filter.svg",
	"./icon-graphs.svg": "./svg/icon-graphs.svg",
	"./icon-hart.svg": "./svg/icon-hart.svg",
	"./icon-instagram.svg": "./svg/icon-instagram.svg",
	"./icon-leisure.svg": "./svg/icon-leisure.svg",
	"./icon-life-science-health.svg": "./svg/icon-life-science-health.svg",
	"./icon-linkedin.svg": "./svg/icon-linkedin.svg",
	"./icon-mail.svg": "./svg/icon-mail.svg",
	"./icon-marker-hotspot-red.svg": "./svg/icon-marker-hotspot-red.svg",
	"./icon-marker-hotspot.svg": "./svg/icon-marker-hotspot.svg",
	"./icon-marker.svg": "./svg/icon-marker.svg",
	"./icon-menu.svg": "./svg/icon-menu.svg",
	"./icon-messenger.svg": "./svg/icon-messenger.svg",
	"./icon-phone.svg": "./svg/icon-phone.svg",
	"./icon-pinterest.svg": "./svg/icon-pinterest.svg",
	"./icon-plus.svg": "./svg/icon-plus.svg",
	"./icon-quote.svg": "./svg/icon-quote.svg",
	"./icon-read-more.svg": "./svg/icon-read-more.svg",
	"./icon-search-secondary.svg": "./svg/icon-search-secondary.svg",
	"./icon-search-white.svg": "./svg/icon-search-white.svg",
	"./icon-search.svg": "./svg/icon-search.svg",
	"./icon-skype.svg": "./svg/icon-skype.svg",
	"./icon-snapchat.svg": "./svg/icon-snapchat.svg",
	"./icon-star.svg": "./svg/icon-star.svg",
	"./icon-sticky.svg": "./svg/icon-sticky.svg",
	"./icon-telegram.svg": "./svg/icon-telegram.svg",
	"./icon-tiktok.svg": "./svg/icon-tiktok.svg",
	"./icon-twitter.svg": "./svg/icon-twitter.svg",
	"./icon-vimeo.svg": "./svg/icon-vimeo.svg",
	"./icon-whatsapp.svg": "./svg/icon-whatsapp.svg",
	"./icon-world.svg": "./svg/icon-world.svg",
	"./icon-youtube.svg": "./svg/icon-youtube.svg",
	"./logo-bbr-white.svg": "./svg/logo-bbr-white.svg",
	"./logo-bbr.svg": "./svg/logo-bbr.svg",
	"./logo-bib-bom.svg": "./svg/logo-bib-bom.svg",
	"./logo-bom.svg": "./svg/logo-bom.svg",
	"./logo-brabantisbright.svg": "./svg/logo-brabantisbright.svg",
	"./logo-invest-in-holland.svg": "./svg/logo-invest-in-holland.svg",
	"./scroll-down.svg": "./svg/scroll-down.svg",
	"./shape-brabant.svg": "./svg/shape-brabant.svg",
	"./visual-hero.svg": "./svg/visual-hero.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./svg sync recursive \\.svg$";